import { render } from "./CompanyStockView.vue?vue&type=template&id=6955d5df&ts=true"
import script from "./CompanyStockView.vue?vue&type=script&lang=ts"
export * from "./CompanyStockView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__